export default __webpack_public_path__ + "072792c86e61dc60aba50d3e8d1b0ee7.svg";